export const version = '0.769.1'
export const chameleonWebVersion = '9.6.1'
export const chameleonCoreVersion = '7.8.0'
